import React from 'react';
import { Helmet as ReactHelmet } from 'react-helmet';

const toStructuredDataList = (structuredData) => {
  if (!structuredData) {
    return [];
  }
  return Array.isArray(structuredData) ? structuredData : [structuredData];
};

export default function Helmet({ title, description, keywords, structuredData }) {
  const structuredDataList = toStructuredDataList(structuredData);

  return (
    <ReactHelmet>
      {title ? <title>{title}</title> : null}
      {title ? <meta property="og:title" content={title} /> : null}
      {description ? <meta name="description" content={description} /> : null}
      {description ? <meta property="og:description" content={description} /> : null}
      {keywords ? <meta name="keywords" content={keywords} /> : null}
      {structuredDataList.map((data, index) => (
        <script key={index} type="application/ld+json">
          {JSON.stringify(data)}
        </script>
      ))}
    </ReactHelmet>
  );
}
